import {
	ButtonColors,
	Button as ButtonComponent,
	ButtonHeight,
} from '~/components/ui/Button';
import { Text } from '~/components/ui/Text';
import { Spinner } from '../Spinner';
import { IButtonProps } from './Button.model';

const Button = ({
	primary,
	loading,
	disabled,
	children,
	onMouseEnter,
	...props
}: IButtonProps): JSX.Element => {
	return (
		<ButtonComponent
			height={ButtonHeight.Height50}
			disabled={loading || disabled}
			onMouseEnter={onMouseEnter}
			style={{ fontSize: 16, ...props.style }}
			{...props}
			color={primary ? ButtonColors.Select : ButtonColors.Default}
		>
			{loading ? <Spinner /> : <Text>{children}</Text>}
		</ButtonComponent>
	);
};

export { Button };
